module.exports = __webpack_public_path__ + "media/images/app/products/index/occassions/professional-828a1f09119e4af7a1710b285f9bbf7f.webp";